/* =========================================================
   LabelKoning — custom.js
   Plaats dit bestand in: assets/lk-custom.js
   Gebruikt Shopify's eigen Cart AJAX API (/cart/add.js, /cart.js,
   /cart/change.js) — dit is de ECHTE winkelwagen van je winkel,
   geen simulatie.
   ========================================================= */

const LK_FREE_SHIPPING_CENTS = 5000; // €50,00 — pas aan indien gewenst

// ===== PREORDER-SCHAKELAAR =====
// Zet hieronder op 'true' om de preorder-melding in de winkelwagen aan te
// zetten, of op 'false' om 'm helemaal uit te zetten. Moet hetzelfde staan
// als LK_PREORDER_MODE in main-product-lk.liquid.
const LK_PREORDER_MODE = false;

// Producten waarvoor momenteel een preorder-melding geldt (levering pas
// begin oktober). Voeg of verwijder handles hier om dit later aan te passen.
const LK_PREORDER_HANDLES = [
  '10x15-printer',
  '10x15-labelprinter-bundel-labelhouder-100-labels-bundel-labelkoning-dhl-postnl'
];
const LK_PREORDER_TEXT = '📦 Levering pas in de week van 5-9 oktober (kan eerder zijn). Je wordt per e-mail op de hoogte gehouden.';

function lkMoney(cents){
  return '€' + (cents/100).toFixed(2).replace('.', ',');
}

/* ---------- CART STATE ---------- */
async function lkFetchCart(){
  const res = await fetch('/cart.js');
  return res.json();
}

async function lkAddToCart(variantId, quantity){
  quantity = quantity || 1;
  const res = await fetch('/cart/add.js', {
    method:'POST',
    headers:{'Content-Type':'application/json', 'Accept':'application/json'},
    body: JSON.stringify({ items:[{ id: variantId, quantity: quantity }] })
  });
  if(!res.ok){
    const err = await res.json();
    lkToast(err.description || 'Kon product niet toevoegen');
    return null;
  }
  await lkRenderCart();
  lkOpenCart();
  return res.json();
}

async function lkChangeCartLine(line, quantity){
  if(quantity < 0) quantity = 0;
  await fetch('/cart/change.js', {
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body: JSON.stringify({ line: line, quantity: quantity })
  });
  await lkRenderCart();
}

/* ---------- RENDER CART DRAWER ---------- */
async function lkRenderCart(){
  const cart = await lkFetchCart();
  const itemsEl = document.getElementById('lk-cart-items');
  const footEl = document.getElementById('lk-cart-foot');
  const countEl = document.getElementById('lk-cart-count');
  if(!itemsEl) return cart;

  if(countEl){
    countEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
    countEl.textContent = cart.item_count;
  }

  if(cart.items.length === 0){
    itemsEl.innerHTML = '<div class="lk-cart-empty">Je winkelwagen is leeg.</div>';
    if(footEl) footEl.style.display = 'none';
    const upsellWrap = document.getElementById('lk-cart-upsells-wrap');
    if(upsellWrap) upsellWrap.innerHTML = '';
  } else {
    itemsEl.innerHTML = cart.items.map((item, i) => {
      const isPreorder = LK_PREORDER_MODE && LK_PREORDER_HANDLES.includes(item.handle);
      return `
      <div class="lk-cart-row">
        <img src="${item.image ? item.image.replace('.jpg','_100x.jpg').replace('.png','_100x.png') : ''}" alt="${item.product_title}">
        <div class="lk-row-info">
          <div class="lk-row-name">${item.product_title}</div>
          <div class="lk-row-price">${lkMoney(item.price)} per stuk</div>
          <div class="lk-cart-qty-stepper">
            <button type="button" onclick="lkChangeCartLine(${i+1}, ${item.quantity - 1})">−</button>
            <span>${item.quantity}</span>
            <button type="button" onclick="lkChangeCartLine(${i+1}, ${item.quantity + 1})">+</button>
          </div>
          ${isPreorder ? `<div class="lk-cart-preorder-note">${LK_PREORDER_TEXT}</div>` : ''}
        </div>
        <button type="button" class="lk-remove-btn" onclick="lkChangeCartLine(${i+1}, 0)" aria-label="Verwijderen" title="Verwijderen">✕</button>
      </div>`;
    }).join('');
    if(footEl) footEl.style.display = 'block';
    lkRenderCartUpsells(cart);
  }

  const totalEl = document.getElementById('lk-cart-total');
  if(totalEl) totalEl.textContent = lkMoney(cart.total_price);

  const remaining = Math.max(0, LK_FREE_SHIPPING_CENTS - cart.total_price);
  const pct = Math.min(100, Math.round((cart.total_price / LK_FREE_SHIPPING_CENTS) * 100));
  const fillEl = document.getElementById('lk-csb-fill');
  if(fillEl) fillEl.style.width = pct + '%';
  const txtEl = document.getElementById('lk-csb-text');
  if(txtEl){
    txtEl.innerHTML = remaining > 0
      ? `Nog <b>${lkMoney(remaining)}</b> tot gratis verzending`
      : `<span class="lk-csb-free-text">🎉 GRATIS VERZENDING!</span>`;
  }

  // Vier het moment dat de drempel voor gratis verzending net bereikt wordt
  // (dus niet bij elke render, alleen op het exacte omslagpunt).
  if(lkPrevShippingRemaining !== null && lkPrevShippingRemaining > 0 && remaining <= 0){
    lkCelebrateFreeShipping();
  }
  lkPrevShippingRemaining = remaining;

  window._lkCart = cart;
  return cart;
}

let lkPrevShippingRemaining = null;

function lkCelebrateFreeShipping(){
  const bar = document.querySelector('.lk-cart-shipping-bar');
  if(!bar) return;

  bar.classList.add('lk-shipping-celebrate');
  setTimeout(() => bar.classList.remove('lk-shipping-celebrate'), 550);

  const colors = ['#C9A24B', '#25476A', '#1E7A4C', '#C1442B'];
  for(let i = 0; i < 14; i++){
    const piece = document.createElement('div');
    piece.className = 'lk-confetti-piece';
    piece.style.left = (Math.random() * 90 + 5) + '%';
    piece.style.background = colors[Math.floor(Math.random() * colors.length)];
    piece.style.animationDelay = (Math.random() * 150) + 'ms';
    bar.appendChild(piece);
    setTimeout(() => piece.remove(), 1300);
  }
}

/* ---------- WINKELWAGEN-UPSELLS: gericht op wat er al in de winkelwagen zit ---------- */
const LK_CART_UPSELL_MAP = {
  'mini-draagbare-labelprinter': ['rollen-voor-de-mini-labelprinter', 'reserve-oplaadkabel-voor-de-mini-labelprinter-1-meter-lang'],
  'bundel': ['rollen-voor-de-mini-labelprinter', 'reserve-oplaadkabel-voor-de-mini-labelprinter-1-meter-lang'],
  '10x15-printer': ['print-papier', 'products-labelhouder-10x15-verzendlabels'],
  '10x15-labelprinter-bundel-labelhouder-100-labels-bundel-labelkoning-dhl-postnl': ['print-papier']
};

async function lkRenderCartUpsells(cart){
  let upsellWrap = document.getElementById('lk-cart-upsells-wrap');

  if(!upsellWrap){
    const footEl = document.getElementById('lk-cart-foot');
    if(!footEl) return;
    upsellWrap = document.createElement('div');
    upsellWrap.id = 'lk-cart-upsells-wrap';
    footEl.parentNode.insertBefore(upsellWrap, footEl);
  }

  const cartHandles = cart.items.map(i => i.handle);

  let suggestedHandles = [];
  cartHandles.forEach(handle => {
    const suggestions = LK_CART_UPSELL_MAP[handle];
    if(suggestions){
      suggestions.forEach(s => {
        if(!cartHandles.includes(s) && !suggestedHandles.includes(s)){
          suggestedHandles.push(s);
        }
      });
    }
  });

  suggestedHandles = suggestedHandles.slice(0, 2);

  if(suggestedHandles.length === 0){
    upsellWrap.innerHTML = '';
    return;
  }

  try{
    const products = await Promise.all(
      suggestedHandles.map(handle =>
        fetch('/products/' + handle + '.js').then(r => r.ok ? r.json() : null)
      )
    );

    const validProducts = products.filter(p => p && p.available);
    if(validProducts.length === 0){
      upsellWrap.innerHTML = '';
      return;
    }

    upsellWrap.innerHTML = `
      <div class="lk-cart-upsells">
        <div class="lk-cart-upsells-title">Vaak samen besteld</div>
        ${validProducts.map(p => {
          const variant = p.variants.find(v => v.available) || p.variants[0];
          const img = p.featured_image ? p.featured_image.replace('.jpg','_100x.jpg').replace('.png','_100x.png') : '';
          return `
            <div class="lk-cart-upsell-item">
              <img src="${img}" alt="${p.title}">
              <div class="lk-cart-upsell-info">
                <div class="lk-cart-upsell-name">${p.title}</div>
                <div class="lk-cart-upsell-price">${lkMoney(variant.price)}</div>
              </div>
              <button type="button" class="lk-cart-upsell-add" data-variant-id="${variant.id}" onclick="lkAddCartUpsellItem(${variant.id}, this)">+</button>
            </div>`;
        }).join('')}
      </div>`;
  }catch(e){
    upsellWrap.innerHTML = '';
  }
}

async function lkAddCartUpsellItem(variantId, btn){
  btn.disabled = true;
  const result = await lkAddToCart(variantId, 1);
  if(result){
    btn.textContent = '✓';
    btn.classList.add('added');
  } else {
    btn.disabled = false;
  }
}

/* ---------- ACHTERGROND VERGRENDELEN ---------- */
function lkLockScroll(){ document.body.classList.add('lk-scroll-locked'); }
function lkUnlockScroll(){ document.body.classList.remove('lk-scroll-locked'); }

function lkOpenCart(){
  document.getElementById('lk-cart-overlay').classList.add('open');
  document.getElementById('lk-cart-drawer').classList.add('open');
  lkLockScroll();
}
function lkCloseCart(){
  document.getElementById('lk-cart-overlay').classList.remove('open');
  document.getElementById('lk-cart-drawer').classList.remove('open');
  lkUnlockScroll();
}

/* ---------- CHECKOUT + VERZENDZAKKEN UPSELL ---------- */
const LK_UPSELL_HANDLE = 'verzendzakken';
let lkUpsellSelectedVariantId = null;

async function lkRenderUpsellVariants(){
  try{
    const res = await fetch('/products/' + LK_UPSELL_HANDLE + '.js');
    if(!res.ok) return false;
    const product = await res.json();

    const img = product.featured_image ? product.featured_image.replace('.jpg','_150x.jpg').replace('.png','_150x.png') : '';
    const imgEl = document.getElementById('lk-upsell-img');
    imgEl.src = img;
    imgEl.style.display = img ? 'block' : 'none';

    const variantsWrap = document.getElementById('lk-upsell-variants');
    variantsWrap.innerHTML = product.variants.map(function(v, i){
      const disabled = !v.available;
      // De 25-stuks variant krijgt een opvallende "Gratis verzending"-badge.
      const isFreeShippingVariant = /^\s*25\b/.test(v.title);
      const badge = isFreeShippingVariant
        ? '<span style="display:inline-flex;align-items:center;gap:6px;margin:0 auto;padding:7px 16px;border-radius:999px;background:linear-gradient(135deg,#C9972F,#E6C27A);color:#1C3A57;font-size:14px;font-weight:800;letter-spacing:.4px;text-transform:uppercase;box-shadow:0 2px 8px rgba(184,134,46,.45);white-space:nowrap;">🚚 Gratis verzending</span>'
        : '';
      const highlight = isFreeShippingVariant ? 'border:2px solid #B8862E !important;background:#FFF8E8;' : '';
      return '<div class="lk-cu-pill ' + (i===0 && !disabled ? 'selected':'') + ' ' + (disabled?'disabled':'') + '"' +
             ' style="' + highlight + '"' +
             ' data-variant-id="' + v.id + '"' +
             ' onclick="' + (disabled ? '' : 'lkSelectUpsellVariant(' + v.id + ', this)') + '">' +
             (v.title === 'Default Title' ? product.title : v.title) +
             badge +
             '<span class="lk-cu-pill-price">' + lkMoney(v.price) + '</span></div>';
    }).join('');

    const firstAvailable = product.variants.find(function(v){ return v.available; });
    lkUpsellSelectedVariantId = firstAvailable ? firstAvailable.id : null;
    return true;
  }catch(e){ return false; }
}

function lkSelectUpsellVariant(variantId, el){
  lkUpsellSelectedVariantId = variantId;
  document.querySelectorAll('#lk-upsell-variants .lk-cu-pill').forEach(function(p){ p.classList.remove('selected'); });
  el.classList.add('selected');
}

async function lkAttemptCheckout(){
  const cart = await lkFetchCart();
  if(cart.items.length === 0) return;

  const alreadyHasZakken = cart.items.some(function(i){ return i.handle === LK_UPSELL_HANDLE; });
  if(alreadyHasZakken){
    window.location.href = '/checkout';
    return;
  }
  const loaded = await lkRenderUpsellVariants();
  if(!loaded){
    window.location.href = '/checkout';
    return;
  }
  document.getElementById('lk-upsell-overlay').classList.add('open');
  lkLockScroll();
}

async function lkAddUpsellAndCheckout(){
  if(lkUpsellSelectedVariantId) await lkAddToCart(lkUpsellSelectedVariantId, 1);
  document.getElementById('lk-upsell-overlay').classList.remove('open');
  lkUnlockScroll();
  window.location.href = '/checkout';
}
function lkSkipUpsellAndCheckout(){
  document.getElementById('lk-upsell-overlay').classList.remove('open');
  lkUnlockScroll();
  window.location.href = '/checkout';
}

/* ---------- TOAST ---------- */
let lkToastTimer;
function lkToast(msg){
  const el = document.getElementById('lk-toast');
  if(!el) return;
  el.textContent = msg;
  el.style.display = 'block';
  clearTimeout(lkToastTimer);
  lkToastTimer = setTimeout(()=>{ el.style.display='none'; }, 2600);
}

/* ---------- PRODUCT PAGE: galerij ---------- */
function lkSetMainImage(src, el){
  if(!src) return;
  document.getElementById('lk-pp-main-img').src = src;
  document.querySelectorAll('.lk-pp-thumbs img').forEach(i => i.classList.remove('active'));
  if(el) el.classList.add('active');
}

/* ---------- PRODUCT PAGE: variant picker ---------- */
function lkInitVariantPicker(productJson){
  const product = productJson;
  let selectedOptions = product.options.map(() => null);
  const optionEls = document.querySelectorAll('[data-lk-option-index]');

  function findVariant(){
    return product.variants.find(v =>
      v.options.every((val, i) => selectedOptions[i] === null || selectedOptions[i] === val)
    );
  }

  function updateUI(){
    const variant = findVariant();
    if(!variant) return;

    const priceEl = document.getElementById('lk-pp-price-now');
    const wasEl = document.getElementById('lk-pp-price-was');
    if(priceEl) priceEl.textContent = lkMoney(variant.price_cents);
    if(wasEl){
      if(variant.compare_at_price_cents && variant.compare_at_price_cents > variant.price_cents){
        wasEl.style.display = 'inline'; wasEl.textContent = lkMoney(variant.compare_at_price_cents);
      } else { wasEl.style.display = 'none'; }
    }

    const addBtn = document.getElementById('lk-add-to-cart-btn');
    if(addBtn){
      addBtn.disabled = !variant.available;
      addBtn.dataset.variantId = variant.id;
    }

    const stockBadge = document.getElementById('lk-stock-badge');
    const stockBadgeText = document.getElementById('lk-stock-badge-text');
    if(stockBadge && stockBadgeText){
      const qty = variant.inventory_quantity;
      const tracked = variant.inventory_management === 'shopify';
      if(tracked && typeof qty === 'number' && qty > 0 && qty <= 3){
        stockBadgeText.textContent = qty === 1 ? 'Nog maar 1 op voorraad!' : `Nog maar ${qty} op voorraad!`;
        stockBadge.style.display = 'flex';
      } else {
        stockBadge.style.display = 'none';
      }
    }

    const freeShipBadge = document.getElementById('lk-pp-free-shipping-badge');
    if(freeShipBadge){
      freeShipBadge.style.display = variant.price_cents >= LK_FREE_SHIPPING_CENTS ? 'inline' : 'none';
    }

    if(variant.image){
      lkSetMainImage(variant.image, null);
      document.querySelectorAll('.lk-pp-thumbs img').forEach(img => {
        img.classList.toggle('active', img.dataset.fullSrc === variant.image);
      });
    }
  }

  optionEls.forEach(el => {
    el.addEventListener('click', () => {
      const idx = parseInt(el.dataset.lkOptionIndex, 10);
      const group = document.querySelectorAll(`[data-lk-option-index="${idx}"]`);
      group.forEach(g => g.classList.remove('selected'));
      el.classList.add('selected');
      selectedOptions[idx] = el.dataset.lkValue;
      updateUI();
    });
  });

  updateUI();
}

/* ---------- PRODUCT PAGE: printer-of-bundel-keuze (10x15 printer) ---------- */
const LK_BUNDLE_PICKER_HANDLE = '10x15-labelprinter-bundel-labelhouder-100-labels-bundel-labelkoning-dhl-postnl';

async function lkInitBundlePicker(){
  const picker = document.getElementById('lk-bundle-picker');
  if(!picker) return;

  try{
    const res = await fetch('/products/' + LK_BUNDLE_PICKER_HANDLE + '.js');
    if(!res.ok) return;
    const bundleProduct = await res.json();
    const bundleVariant = bundleProduct.variants.find(v => v.available);
    if(!bundleVariant) return;

    window._lkBundlePickerVariantId = bundleVariant.id;

    const priceEl = document.getElementById('lk-bundle-picker-bundle-price');
    const optEl = document.getElementById('lk-bundle-picker-bundle-opt');
    if(priceEl) priceEl.textContent = lkMoney(bundleVariant.price);
    if(optEl) optEl.style.display = 'flex';
  }catch(e){
    // Kon bundelgegevens niet ophalen — de keuze blijft dan gewoon
    // verborgen, alleen de losse printer-optie is dan zichtbaar.
  }

  picker.querySelectorAll('input[name="lk-bundle-choice"]').forEach(input => {
    input.addEventListener('change', () => {
      picker.querySelectorAll('.lk-bundle-picker-opt').forEach(opt => opt.classList.remove('selected'));
      input.closest('.lk-bundle-picker-opt').classList.add('selected');
    });
  });
}

/* ---------- FAQ ACCORDION ---------- */
function lkInitFaq(){
  document.querySelectorAll('.lk-faq-item').forEach(item=>{
    const q = item.querySelector('.lk-faq-q');
    const a = item.querySelector('.lk-faq-a');
    if(!q || !a) return;
    q.addEventListener('click', () => {
      const open = item.classList.contains('open');
      document.querySelectorAll('.lk-faq-item').forEach(i=>{
        i.classList.remove('open');
        i.querySelector('.lk-faq-a').style.maxHeight = null;
      });
      if(!open){ item.classList.add('open'); a.style.maxHeight = a.scrollHeight + 'px'; }
    });
  });
}

/* ---------- ASSORTIMENT: sorteren binnen een categorie ---------- */
function lkSortGroup(gridId, mode){
  const grid = document.getElementById(gridId);
  if(!grid) return;
  const cards = Array.from(grid.children);

  function priceOf(card){
    const el = card.querySelector('.lk-prod-price .now');
    if(!el) return 0;
    return parseFloat(el.textContent.replace(/[^\d,.-]/g,'').replace(',', '.')) || 0;
  }
  function nameOf(card){
    const el = card.querySelector('.lk-prod-name');
    return el ? el.textContent.trim().toLowerCase() : '';
  }

  if(mode === 'price-asc') cards.sort((a,b) => priceOf(a) - priceOf(b));
  else if(mode === 'price-desc') cards.sort((a,b) => priceOf(b) - priceOf(a));
  else if(mode === 'name-asc') cards.sort((a,b) => nameOf(a).localeCompare(nameOf(b)));
  else return;

  cards.forEach(c => grid.appendChild(c));
}

/* ---------- CROSS-SELL: pop-up direct na toevoegen van een printer ---------- */
const CROSS_UPSELL_MAP = {
  'mini-draagbare-labelprinter': {
    relatedHandle: 'rollen-voor-de-mini-labelprinter',
    title: 'Mini printrolletjes erbij?',
    text: 'Voor de Mini Labelprinter heb je deze rolletjes nodig — kies direct de juiste variant.',
    showVolumeDiscount: false
  },
  '10x15-printer': {
    relatedHandle: 'print-papier',
    title: 'Printpapier voor je 10x15 printer?',
    text: 'Deze labelprinter heeft dit papier nodig om mee te kunnen printen — meteen erbij bestellen scheelt een aparte bestelling.',
    showVolumeDiscount: true
  },
  '10x15-labelprinter-bundel-labelhouder-100-labels-bundel-labelkoning-dhl-postnl': {
    relatedHandle: 'print-papier',
    title: 'Extra printpapier bijbestellen?',
    text: 'Je bundel bevat al 100 labels om mee te starten. Wil je verzekerd zijn van genoeg voorraad, bestel dan gelijk wat extra printpapier erbij.',
    showVolumeDiscount: true
  }
};

let lkCrossUpsellVariantId = null;
let lkCrossUpsellQuantity = 1;

function lkUpdateCrossUpsellQtyUI(){
  const qtyEl = document.getElementById('lk-cu-qty-value');
  if(qtyEl) qtyEl.textContent = lkCrossUpsellQuantity;
}

function lkCrossUpsellQtyDown(){
  if(lkCrossUpsellQuantity <= 1) return;
  lkCrossUpsellQuantity -= 1;
  lkUpdateCrossUpsellQtyUI();
}
function lkCrossUpsellQtyUp(){
  lkCrossUpsellQuantity += 1;
  lkUpdateCrossUpsellQtyUI();
}

async function lkCheckCrossUpsell(handle){
  const config = CROSS_UPSELL_MAP[handle];
  if(!config) return;

  try{
    const res = await fetch('/products/' + config.relatedHandle + '.js');
    if(!res.ok) return;
    const product = await res.json();

    document.getElementById('lk-cu-title').textContent = config.title;
    document.getElementById('lk-cu-text').textContent = config.text;
    const img = product.featured_image ? product.featured_image.replace('.jpg','_150x.jpg').replace('.png','_150x.png') : '';
    document.getElementById('lk-cu-img').src = img;
    document.getElementById('lk-cu-img').style.display = img ? 'block' : 'none';

    const pillsWrap = document.getElementById('lk-cu-variants');
    pillsWrap.innerHTML = product.variants.map((v, i) => {
      const disabled = !v.available;
      return `<div class="lk-cu-pill ${i===0 && !disabled ? 'selected':''} ${disabled?'disabled':''}"
                   data-variant-id="${v.id}" data-price="${v.price}"
                   onclick="${disabled ? '' : `lkSelectCrossVariant(${v.id}, this)`}">
                ${v.title === 'Default Title' ? product.title : v.title}
                <span class="lk-cu-pill-price">${lkMoney(v.price)}</span>
              </div>`;
    }).join('');

    const firstAvailable = product.variants.find(v => v.available);
    lkCrossUpsellVariantId = firstAvailable ? firstAvailable.id : null;

    lkCrossUpsellQuantity = 1;
    lkUpdateCrossUpsellQtyUI();
    const bannerWrap = document.getElementById('lk-cu-discount-banner-wrap');
    if(bannerWrap){
      bannerWrap.style.display = config.showVolumeDiscount ? 'block' : 'none';
    }
    const bannerEl = document.getElementById('lk-cu-discount-banner');
    if(bannerEl){
      bannerEl.style.display = config.showVolumeDiscount ? 'flex' : 'none';
    }

    document.getElementById('lk-cross-upsell-overlay').classList.add('open');
    lkLockScroll();
  }catch(e){
    // Kon de gekoppelde productgegevens niet ophalen — geen pop-up tonen.
  }
}
function lkSelectCrossVariant(variantId, el){
  lkCrossUpsellVariantId = variantId;
  document.querySelectorAll('.lk-cu-pill').forEach(p => p.classList.remove('selected'));
  el.classList.add('selected');
}
async function lkAddCrossUpsell(){
  if(!lkCrossUpsellVariantId){ lkCloseCrossUpsell(); return; }
  await lkAddToCart(lkCrossUpsellVariantId, lkCrossUpsellQuantity);
  lkCloseCrossUpsell();
}
function lkCloseCrossUpsell(){
  document.getElementById('lk-cross-upsell-overlay').classList.remove('open');
  lkUnlockScroll();
}

/* ---------- INIT ---------- */
document.addEventListener('DOMContentLoaded', () => {
  lkRenderCart();
  lkInitFaq();
  lkInitBundlePicker();

  document.querySelectorAll('[data-lk-add-to-cart]').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      let variantId = btn.dataset.variantId || btn.dataset.lkAddToCart;
      const handle = btn.dataset.productHandle;
      const qtyInput = document.getElementById('lk-qty-input');
      const qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

      if(btn.id === 'lk-add-to-cart-btn' && window._lkBundlePickerVariantId){
        const selected = document.querySelector('input[name="lk-bundle-choice"]:checked');
        if(selected && selected.value === 'bundel'){
          variantId = window._lkBundlePickerVariantId;
        }
      }

      const result = await lkAddToCart(variantId, qty);

      if(result && btn.id === 'lk-add-to-cart-btn'){
        btn.classList.add('lk-added');
        setTimeout(() => {
          btn.classList.remove('lk-added');
        }, 1800);
      }

      if(handle){ await lkCheckCrossUpsell(handle); }
    });
  });

  const nlForm = document.getElementById('lk-newsletter-form');
  if(nlForm){
    nlForm.addEventListener('submit', () => {
      lkToast('Bedankt voor je aanmelding!');
    });
  }
});

/* ---------- SOCIAAL BEWIJS ----------
   Deze logica staat nu (bijgewerkt, met per-product tempo) in
   sections/main-product-lk.liquid zelf, zodat hij samen met de rest
   van de productpagina-logica op één plek staat. Hier bewust leeg
   gelaten om dubbele/conflicterende functienamen te voorkomen. */